import { fetcher } from '@commenda/utils';

export async function deleteCustomer(
  customerId: string,
  corporationId: number
): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/customers/${customerId}?corporation_id=${corporationId}`,
      {
        method: 'DELETE',
      },
      undefined
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to delete customer',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: 'An unexpected error occurred while deleting the customer',
    };
  }
}
